var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"p-m01-account-anchor"},[_vm._t("default"),_c('IconBase',{staticClass:"p-m01-account-anchor__icon",attrs:{"view-box":"0 0 24 24","width":"24","height":"24"}},[_c('IconArrowRight')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }